var angular = require('angular');
var ApplicationAPI = require('../../api/application');


 angular
  .module("app.directives")
  .directive('featuredProjects', function($interval){
    return {
      restrict: 'E',
      scope:true,
      replace:true,
      template: require('./index.pug'),
      link: function(scope, element, attrs){

        scope.preloading = true;
        // blank objects for preloading
        scope.items = [{}, {}, {}];

        scope.init = function(){
          return ApplicationAPI.GetFeatured().then(function(resp){
            scope.preloading = false;
            scope.items = resp.results.map(function(item){
              // trim description
              var maxLength = 200
              var trimmedString = item.projectDescription.substr(0, maxLength);
              trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))
              if (item.projectDescription.length > 200) {
                trimmedString += "..."
              }
              item.description = trimmedString;
              return item;
            })
          })
        }

        scope.init();
      }
    }
  })
